import React from "react";
import { useInView } from "react-intersection-observer";

const BulkActionColumn = ({ children }) => {
  const { ref, inView, entry } = useInView(
    { threshold: 1, triggerOnce: true });

  if (!inView && entry) {
    entry?.target?.scrollIntoView({ behavior: "smooth", block: "center", inline: "end" });
  }

  return <div ref={ref}>
    {children}
  </div>;
};

export default BulkActionColumn;
